import(/* webpackMode: "eager" */ "/app/apps/planner/src/app/global-error.tsx");
